import { Globals } from "../CoreApp/Globals";
import { enumImportStep } from "../constants";

export function handleImportAdvance() {
  var w = Globals._wsMgr;
  if (w) {
    var nextStep = w["importstep"];
    switch (nextStep) {
      case enumImportStep.loadDB:
        w.LoadDB();
        break;
      case enumImportStep.loadBambooDB:
      case enumImportStep.loadPeopleHRDB:
      case enumImportStep.loadADPWorkforceNowDB:
      case enumImportStep.loadSubscribeHRDB:
      case enumImportStep.loadUltimateDB:
      case enumImportStep.loadUltimateBIDB:
      case enumImportStep.loadSutiHRDB:
      case enumImportStep.loadODBC:
      case enumImportStep.loadSalesForceDB:
      case enumImportStep.loadSFSFDB:
      case enumImportStep.loadPaySpaceDB:
      case enumImportStep.loadGoogleDB:
      case enumImportStep.loadBreatheHRDB:
      case enumImportStep.loadOrangeDB:
      case enumImportStep.loadNamelyDB:
      case enumImportStep.loadWorkdayDB:
      case enumImportStep.loadGreenHouseDB:
      case enumImportStep.loadSignifyDB:
      case enumImportStep.loadSAPDB:
      case enumImportStep.loadChartBuilderDB:
      case enumImportStep.loadCustomDB:
        w.LoadCloudData(nextStep);
        break;
      case enumImportStep.appenddata:
        w.AppendData();
        break;
      case enumImportStep.buildhier:
        w.BuildHierarchy();
        break;
      case enumImportStep.finishimport:
        w.FinishImport();
        break;
    }
    if (w.fWaiting == null) {
      if (w.fPostRefreshCallback) w.fPostRefreshCallback.PostDocRefresh();
      w.fPostRefreshCallback = null;
    }
    w.PrepRenderWS();
    w.RenderWS();
  }
}
